import {
  leadsLogsListQueryKey,
  logsNoteCreateMutation,
  opportunitiesLogsListOptions,
  usersListListInfiniteQueryKey
} from '@crm/api'
import { LogAction, LogType } from '@crm/types'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'
import { Button, Col, Form, Input, Row } from 'antd'
import { useParams } from 'react-router-dom'

interface NoteFormProps {
  onCloseForm: () => void
}

export const NoteForm = ({ onCloseForm }: NoteFormProps) => {
  const { t } = useLocales()
  const { opportunityId, id: leadId } = useParams()
  const [form] = Form.useForm()
  const { invalidateQueries } = useInvalidatePredicateQueries()

  const { mutate: postMutation } = useMutation({
    ...logsNoteCreateMutation(),
    onError: (e) => showApiErrors(e),
    onSuccess: () => onSuccessMutation()
  })

  const onSuccessMutation = () => {
    invalidateQueries([
      leadsLogsListQueryKey({ path: { lead_id: String(leadId) } }),
      usersListListInfiniteQueryKey()
    ])

    if (opportunityId) {
      invalidateQueries([
        opportunitiesLogsListOptions({
          path: { opportunity_id: String(opportunityId) }
        })
      ])
    }
    onCloseForm()
  }

  const onSubmit = () => {
    const body = {
      ...form.getFieldsValue(),
      opportunity: opportunityId,
      lead: leadId,
      action: LogAction.UPDATED,
      type: LogType.NOTE
    }

    postMutation({
      body
    })
  }

  const onKeyUp = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && e.metaKey) {
      onSubmit()
    }
  }

  return (
    <Form form={form} onFinish={onSubmit}>
      <Form.Item name="description">
        <Input.TextArea
          placeholder={t('logs.note')}
          rows={4}
          onKeyDown={(e) => onKeyUp(e)}
        />
      </Form.Item>
      <Row justify="space-between">
        <Col>
          <Button onClick={onCloseForm}>{t('buttons.cancel')}</Button>
        </Col>
        <Col>
          <Button type="primary" htmlType="submit">
            {t('buttons.save')}
          </Button>
        </Col>
      </Row>
    </Form>
  )
}
